import { useState } from "react";
import { faqData } from "../../../mocks/fortyone";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-10">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4 leading-snug">
              关于合集整理，你想知道的都在这里
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              从内容整理逻辑到更新方式，我们整理了读者最常问的几个问题。若还有疑问，欢迎通过下方表单告诉我们。
            </p>
            <div className="mt-6 flex flex-col gap-4 max-w-md">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50"><i className="ri-list-check-2 text-lg"></i></span>
                <p className="text-sm text-foreground-700"><strong className="text-foreground-950">公开信息为依据</strong>，逐条按时间收录</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950"><i className="ri-archive-2-line text-lg"></i></span>
                <p className="text-sm text-foreground-700"><strong className="text-foreground-950">系列 + 时间线</strong> 双向检索</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50"><i className="ri-refresh-line text-lg"></i></span>
                <p className="text-sm text-foreground-700"><strong className="text-foreground-950">持续更新</strong>，新进展会补入对应节点</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqData.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-xl bg-background-50 border transition-colors overflow-hidden ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <h3 className="text-sm md:text-base font-bold text-foreground-950">{f.q}</h3>
                    <span
                      className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`}></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}